import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { User } from 'component/stylist_profile_header/types';
import { useAuth } from 'contexts/AuthContext';
import { CREATE_ANSWER } from 'graph_ql/getQuiz/mutation';
import { GET_QUESTION_DATA, GET_QUIZ_RESPONSE } from 'graph_ql/getQuiz/queries';
import { GET_USER_BY_USERNAME } from 'graph_ql/users/queries';
import { useGetGender } from 'hooks/useGetGender';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { setBodyTypeDefault } from 'redux/authentication/user_detail';
import { PATH } from 'routes/constant';
import { EQuestionId, EQuizId, ESubjectQuestion, quizContextType } from 'types/quiz';
import { getValueImageSelect } from 'utils/utils';
import BodyShapeBodyTypeContainer from './body_shape_body_type';

export default function BodyTypeQuiz(props) {
    const history = useHistory();
    const { currentUser } = useAuth();
    const dispatch = useDispatch();
    const { userName } = useParams<{ userName: string }>();
    const gender = useGetGender(Boolean(userName));
    const location = useLocation();
    const [user, setUser] = useState<User>();
    const [defaultValueBodyType, setDefaultValueBodyType] = useState<any>();
    const [requiredQuestion, setRequiredQuestion] = useState(true);
    const [quizData, setQuizData] = useState<any>(null);
    const [getUserByUserName, { loading: userLoading }] = useLazyQuery(GET_USER_BY_USERNAME, {
        onCompleted(data) {
            setUser(data.getUserByUserName);
            getQuizResponse({
                variables: {
                    input: {
                        quizId: EQuizId.BODY_TYPE,
                        contextType: quizContextType,
                        contextId: EQuizId.BODY_TYPE,
                        userId: data.getUserByUserName?.id,
                    },
                },
            });
        },
    });
    useEffect(() => {
        if (userName) {
            getUserByUserName({
                variables: {
                    input: {
                        userName,
                    },
                },
            });
        }
    }, [userName, getUserByUserName]);
    const { data: bodyTypeData } = useQuery(GET_QUESTION_DATA, {
        variables: {
            input: {
                subject: ESubjectQuestion.BODY_TYPE_SUBJECT_QUESTION,
                paging: { page: 0, size: 0 },
                tags: (gender || user?.gender) === 'male' ? ['Man'] : ['Woman'],
                enabled: true,
            },
        },
        skip: Boolean(!userName) ? !gender : !user,
    });
    const listOptionBodyTypes = useMemo(
        () => (bodyTypeData?.getQuestionData?.data || []).map(getValueImageSelect),
        [bodyTypeData?.getQuestionData?.data],
    );
    const [getQuizResponse, { loading: loadingQuiz }] = useLazyQuery(GET_QUIZ_RESPONSE, {
        onCompleted(data) {
            setRequiredQuestion(data.getQuizResponse?.questionsInfo[0]?.required);
            setDefaultValueBodyType(data.getQuizResponse.answers.body_type_question?.value);
            setQuizData(data.getQuizResponse);
        },
    });
    useEffect(() => {
        if (gender) {
            getQuizResponse({
                variables: {
                    input: {
                        quizId: EQuizId.BODY_TYPE,
                        contextType: quizContextType,
                        contextId: EQuizId.BODY_TYPE,
                        userId: currentUser.uid || gender?.id,
                    },
                },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser.uid, gender]);
    const createAnswer = (input: {
        questionId: String;
        questionSubject: String;
        contextType: String;
        contextId: String;
        value: String;
        valueType: String;
        isSkipped?: boolean;
        id?: String;
    }) => {
        const variables = {
            input: { ...input, id: quizData?.answers?.body_type_question?.id },
        };
        answerMutation({ variables });
    };
    const [answerMutation, { loading: loadingAnswer }] = useMutation(CREATE_ANSWER, {
        onCompleted(response) {
            onAnswerCompleted(response);
            dispatch(setBodyTypeDefault(response.createAnswer.value));
        },
        onError(error) {
            console.log('Create Failed: ', error);
        },
    });

    const onAnswerCompleted = async (response: any) => {
        await getQuizResponse({
            variables: {
                input: {
                    quizId: EQuizId.BODY_TYPE,
                    contextType: quizContextType,
                    contextId: EQuizId.BODY_TYPE,
                    userId: currentUser.uid || gender?.id,
                },
            },
        });
        if (location.pathname === PATH.QUIZ_MANAGER) {
            history.push(`${PATH.QUIZ_MANAGER}/?signup=${Date.now()}`);
        }
    };
    return (
        <BodyShapeBodyTypeContainer
            listData={
                Boolean(!userName)
                    ? listOptionBodyTypes.filter((item) => item.imageUrl)
                    : listOptionBodyTypes.filter(
                        (item) => item.value.toLowerCase() === defaultValueBodyType?.toLowerCase(),
                    )
            }
            handleClickAnswer={(input) => (Boolean(!userName) ? createAnswer(input) : null)}
            questionId={EQuestionId.BODY_TYPE}
            questionSubject={ESubjectQuestion.BODY_TYPE_SUBJECT_QUESTION}
            title={Boolean(!userName) ? quizData?.subTitle : ''}
            isUpdate={location.pathname.includes(PATH.MY_STYLE_PREFERENCES)}
            isDisplayContent={Boolean(!userName)}
            titlePage={quizData?.title}
            defaultValue={defaultValueBodyType}
            requiredQuestion={requiredQuestion}
            userName={user?.firstName}
            loadingAnswer={loadingAnswer}
            containerLoading={userLoading || loadingQuiz}
            quizId={EQuizId.BODY_TYPE}
        />
    );
}
